import type { MoveRingAction } from "../types/action";
import type { ValidationResult } from "../types/common";
import type { YinshState } from "../types/game-state";
import { getCellContent } from "../utils/board-utils";
import { getValidRingDestinations } from "../utils/ring-moves";

export function validateMoveRing(
  state: YinshState,
  action: MoveRingAction,
): ValidationResult {
  if (state.phase !== "PLAYING") {
    return { valid: false, error: "Not in playing phase" };
  }
  if (action.player !== state.currentPlayer) {
    return { valid: false, error: "Not your turn" };
  }
  if (state.markerPlacedAt !== action.from) {
    return {
      valid: false,
      error: "Must move the ring you just placed a marker in",
    };
  }
  const dest = getCellContent(state.board, action.to);
  if (dest !== null) {
    return { valid: false, error: "Destination is not empty" };
  }
  const validDests = getValidRingDestinations(state.board, action.from);
  if (!validDests.includes(action.to)) {
    return { valid: false, error: "Illegal ring movement" };
  }
  return { valid: true };
}
